import { render, staticRenderFns } from "./TrademarkApplicationTypeList.vue?vue&type=template&id=07f8efb3&"
import script from "./TrademarkApplicationTypeList.vue?vue&type=script&lang=js&"
export * from "./TrademarkApplicationTypeList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkApplicationTypeList.vue?vue&type=style&index=0&id=07f8efb3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports